



























































































































































































































































import axios from 'axios';
import Producto from '@/models/Producto';
import Resumen from '@/models/Resumen';
import Entidad from '@/models/Entidad.vue';
import Posicion from '@/models/Posicion';
export default {
	name: 'CuentaCorriente',
	inject: ['responsive'],
	data() {
		return {
			pickerBeginDateAfterH: {
				disabledDate: this.disabledDateH,
			},
			pickerBeginDateAfterD: {
				disabledDate: this.disabledDateD,
			},
			radio: 1,
			recordSelected: {
				codalfa: '',
				desart: '',
				coduni: '',
				renglonesComprobantes: [],
				renglonesOtros: [],
			},
			searchDrawer: false,
			detailsDrawer: false,
			imprimiendo: false,
			descargando: false,
			loading: true,
			showBtnMore: false,
			start: 0,
			limit: 0,
			resumen: '',
			descom: '',
			scrollPosition: 0,
			renglonesComprobantes: [],
			searchForm: {
				fechaDesde: '',
				fechaHasta: '',
				tipoctasctes: [],
				productos: [],
				rangofecha: '',
			},
			searchRules: {
				fechaDesde: [{ type: 'date', required: true, message: 'Seleccione una fecha desde', trigger: 'change' }],
				fechaHasta: [{ type: 'date', required: true, message: 'Seleccione una fecha hasta', trigger: 'change' }],
				importefrom: [{ type: 'number', required: false, message: 'Ingrese Importe desde (numérico)', trigger: 'change' }],
				importeto: [{ type: 'number', required: false, message: 'Ingrese Importe hasta (numérico)', trigger: 'change' }],
			},
		};
	},
	watch: {
		$route(to, from) {
			this.loadDataResumen();
		},
	},
	computed: {
		tableData(): Posicion[] {
			return this.$store.state.posiciones.tableData;
		},
		productos(): Producto {
			return this.$store.state.posiciones.tipoProductos;
		},
		resumenes(): Resumen[] {
			return this.$store.state.posiciones.resumenes;
		},
		// tableOtros() {
		// 	return this.$store.state.posiciones.tableOtros;
		// },
		tableOtros(): boolean {
			const r = this.recordSelected;
			return !!(r && r.renglonesOtros && r.renglonesOtros.length);
		},
		titulosColumnas() {
			return this.$store.state.posiciones.titulosColumnas;
		},
		tituloResumen(): string {
			return this.$route.name;
		},
		detalle(): string {
			return `<p style= margin:0>${this.detalle}<br>${this.detalle1}<br>${this.detalle2}<br> ${this.detalle3}</p>`;
		},
		entidadSelected(): Entidad {
			return this.$store.state.perfil.entidadSelected;
		},
	},
	filters: {
		capitalize: function (value: string) {
			if (!value) return '';
			value = value.toString();
			return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
		},
	},
	methods: {
		blurIfRadioActive(evt?: Event) {
			// Si el foco está en el radio nativo, lo sacamos
			const el = document.activeElement as HTMLElement | null;
			if (el && el.classList && el.classList.contains('el-radio__original')) {
				el.blur();
			}
		},
		openSearch() {
			const el = document.activeElement as HTMLElement | null;
			if (el && el.classList.contains('el-radio__original')) el.blur();
			this.searchDrawer = true;
		},
		disabledDateD(date: Date): Boolean {
			if (this.searchForm.fechaHasta) return date > this.searchForm.fechaHasta;
			else return false;
		},
		disabledDateH(date: Date): Boolean {
			if (this.searchForm.fechaDesde) return date < this.searchForm.fechaDesde;
			else return false;
		},
		updateScroll(): void {
			const conta = document.querySelector('.el-main');
			if (conta) this.scrollPosition = conta.scrollTop;
		},
		stylerow({ row, rowIndex }): string {
			return `style-${row.estilo}`;
		},
		clickValor(tipocc: number): void {
			this.searchForm.ctasctes = tipocc;
			this.resetData();
			this.callResumen();
		},
		validDates(fecha: Date): void {
			let date = new Date();
			date.setMonth(date.getMonth() - 12);
			let diff = fecha[1].getTime() - fecha[0].getTime();
			if (diff > 2592000000) {
				this.$message({
					message: 'La diferencia en el rango de fechas no puede ser mayor a 30 dias',
					type: 'warning',
				});
				this.searchForm.rangofecha = '';
			} else if (fecha[0] < date) {
				this.$message({
					message: 'La fecha desde debe estar dentro del último año',
					type: 'warning',
				});
				this.searchForm.rangofecha = '';
			}
		},
		range(array, min, max): object {
			return array.slice(min, max);
		},
		// Muestro el drawer con los detalles del movimiento
		showDetails(record): void {
			this.detailsDrawer = true;
			this.recordSelected = record;
			// this.tableOtros = this.recordSelected.renglonesOtros && this.recordSelected.renglonesOtros.length !== 0;
		},
		// Busqueda que se realiza en el drawer
		doSearch(): void {
			this.searchDrawer = false;

			if (!this.responsive.isMobile) {
				const rf = Array.isArray(this.searchForm.rangofecha) ? this.searchForm.rangofecha : [];
				this.searchForm.fechaDesde = rf[0] ? this.convertDate(rf[0]) : ' ';
				this.searchForm.fechaHasta = rf[1] ? this.convertDate(rf[1]) : ' ';
			} else {
				// ⚠️ En mobile, NO pises el v-model (sigue siendo Date).
				this.searchForm.fechaDesdeM = this.searchForm.fechaDesde ? this.convertDate(this.searchForm.fechaDesde as any) : ' ';
				this.searchForm.fechaHastaM = this.searchForm.fechaHasta ? this.convertDate(this.searchForm.fechaHasta as any) : ' ';
			}

			if (typeof this.resetData === 'function') this.resetData();
			if (typeof this.callResumen === 'function') this.callResumen();
		},
		// doSearch(): void {
		// 	this.searchDrawer = false;
		// 	const desde = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[0]
		// 			? this.convertDate(this.searchForm.rangofecha[0])
		// 			: ' '
		// 		: this.searchForm.fechaDesde
		// 		? this.convertDate(this.searchForm.fechaDesde)
		// 		: ' ';
		// 	this.searchForm.fechaDesde = desde;
		// 	const hasta = !this.responsive.isMobile
		// 		? this.searchForm.rangofecha[1]
		// 			? this.convertDate(this.searchForm.rangofecha[1])
		// 			: ' '
		// 		: this.searchForm.fechaHasta
		// 		? this.convertDate(this.searchForm.fechaHasta)
		// 		: ' ';
		// 	this.searchForm.fechaHasta = hasta;
		// 	this.resetData();
		// 	this.callResumen();
		// },
		convertDate(d: Date): string {
			const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
			const x = new Date(d);
			return `${pad(x.getDate())}/${pad(x.getMonth() + 1)}/${x.getFullYear()}`;
		},
		// convertDate(inputFormat: Date): string {
		// 	function pad(s: number) {
		// 		return s < 10 ? '0' + s : s;
		// 	}
		// 	const d = new Date(inputFormat);
		// 	return [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('/');
		// },
		loadDataResumen(): void {
			this.resetData();
			this.callResumen();
		},
		handleClick(): void {
			this.imprimiendo = true;
			let url = `./api/public/proxy/imprime?codcom=${this.recordSelected.codcom}&codtal=${this.recordSelected.codtal}&numero=${this.recordSelected.numero}`;
			this.$axios
				.get(url)
				.then(response => {
					const x = window.open();
					if (!x) throw new Error();
					x.document.open();
					x.document.write(
						`<iframe width="100%" height="100%" src="data:application/pdf;base64,${response.data.archivos.archivo}"></iframe>`
					);
					x.document.close();
					this.imprimiendo = false;
				})
				.catch(error => {
					this.$notify.error({
						title: 'Error',
						message: 'El movimiento seleccionado no tiene impresión',
						position: 'bottom-right',
					});
					this.imprimiendo = false;
				});
		},
		loadMore(): void {
			if (!this.responsive.isMobile) return;
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		loadMoreClick(): void {
			this.updateScroll();
			this.start = this.start + this.limit;
			this.refresh = false;
			this.callResumen();
		},
		doImprimir(type: string): void {
			let params = {
				url: './api/public/proxy/cgi/etenet_pEntregarStk',
				type: type,
				data: this.loadConfig(),
			};
			window.open(
				`${params.url}?fechaDesde=${params.data.params.fechaDesde}&fechaHasta=${params.data.params.fechaHasta}&codcom=${
					params.data.params.comprobantes
				}&codres=${params.data.params.codres}&grano=${params.data.params.grano}&cosecha=${
					params.data.params.cosecha
				}&token=${localStorage.getItem('accessToken')}&files=true&type=${params.type}&cooperativa=${
					this.$store.state.config.cuit
				}&entity_id=${axios.defaults.headers.common.Entity_ID}`
			);
		},
		resetData() {
			this.$store.dispatch('resetItemsPosicion');
			this.start = 0;
			this.limit = 7;
		},
		callResumen(): void {
			this.loading = true;
			let params = {
				start: this.start,
				limit: this.limit,
				data: this.loadConfig(),
			};
			this.$store.dispatch('callResumenPosiciones', params).then((response: Posicion[]) => {
				if (response) {
					this.loading = false;
					response.length < 7 ? (this.showBtnMore = false) : (this.showBtnMore = true);
					response.sort((a, b) => parseInt(b.id) - parseInt(a.id)); //ordena descendente por id
					this.loading = false;
					this.refresh = false;
					const conta = document.querySelector('.el-main');
					if (conta) conta.scrollTop = this.scrollPosition;
				} else this.loading = false;
			});
		},
		loadConfig(): object {
			const fd = this.responsive.isMobile ? this.searchForm.fechaDesdeM : this.searchForm.fechaDesde;
			const fh = this.responsive.isMobile ? this.searchForm.fechaHastaM : this.searchForm.fechaHasta;
			return {
				params: {
					fechadesde: fd,
					fechahasta: fh,
					codres: this.resumen,
					desart: `[${this.searchForm.productos}]`,
				},
			};
		},
		numberFormatter(row): string {
			return `${row.tvdgi} ${row.letra}  ${row.torig}  ${row.norig}`;
		},
		changeResumen(resumen: Resumen): void {
			this.$nextTick(() => {
				const el = document.activeElement as HTMLElement | null;
				if (el && el.classList.contains('el-radio__original')) el.blur();
			});
			this.resumen = resumen;
			this.loading = true;
			this.resetData();
			this.callResumen();
		},
	},
	mounted() {
		this.loading = true;
		this.agrupactasctes = this.$store.state.perfil.userdata.agrupactasctes;
		this.ocultaMonedas = this.$store.state.perfil.userdata.ocultamonedas;
		this.loadDataResumen();
		window.addEventListener('scroll', this.updateScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.updateScroll);
	},
};
